export const getTextWithoutSpacesAndNewLines = (text: string) =>
  text.replace(/\n/g, "").replace(/ /g, "");
